// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"31d6cfe0","314":"05b8b37b","658":"a5a27984","698":"31d6cfe0"}[chunkId] + ".chunk.css";
};